const categories = [
  'Software engineering',
  'Data science',
  'Computer Science',
  'Artificial intelligence',
  'Computer security',
  ' Web development',
];
export { categories };
